<template>
  <!-- ✕ at the right of a page's title line (SPEC §4.3): leaves settings, the account or the create
       page for the page before them; Esc does the same on a computer. -->
  <button type="button" class="close-page" :aria-label="t('button-close')" :title="t('button-close')" @click="close">✕</button>
</template>

<script>
import { t } from '@/texts';
import { closePage } from '@/navigation';

export default {
  name: 'CloseButton',
  mounted() {
    window.addEventListener('keydown', this.onKey);
  },
  beforeDestroy() {
    window.removeEventListener('keydown', this.onKey);
  },
  methods: {
    t,
    close() {
      closePage();
    },
    onKey(e) {
      if (e.key === 'Escape' && !e.defaultPrevented) this.close();
    },
  },
};
</script>

<style scoped>
/* Round, with the thin wood outline of the other secondary round buttons (⋯). */
.close-page {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  width: 36px;
  height: 36px;
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  box-shadow: none;
  border: 1px solid #c8b28a;
  border-radius: 50%;
  background: #fff;
  color: #5a3e1f;
  font-size: 18px;
  font-weight: normal;
  line-height: 1;
  cursor: pointer;
}
</style>
